import React from "react";
import VehicleManagement from "./VehicleManagement";
import { useTranslation } from 'react-i18next';

const Vehicle: React.FC = () => {
    const { t, i18n } = useTranslation('vehicle');
    return(
        <section className="px-4 py-3 space-y-5">
            <h6 className="font-bold text-title">{t('title.title')}</h6>
            <div>
                <VehicleManagement />
            </div>
        </section> 
    );
}
export default Vehicle;